<script>
    import { onMount } from "svelte";
    let frm_userid = 0;
    let frm_nickname = "";
    let frm_cnname = "";
    let frm_phonenumber = "";
    let frm_sex = "M";
    let frm_title = "";
    let frm_remark = "";
    let frm_createdtime = "";
    let frm_permits = "";
    let detail_url = "/dbapi/userdetail";
    let change_url = "/dbapi/changepass";

    let dlg_oldpwd = "";
    let dlg_newpwd = "";
    let dlg_cftpwd = "";

    toastr.options = {
        positionClass: "toast-top-center",
    };
    onMount(() => {
        LoadoUserDetail();
    });

    function LoadoUserDetail() {
        let cur_nickname = CommonLib.getAppStorage("iotdc_cur_nickname");
        if (!cur_nickname || cur_nickname == "") {
            // toastr.warning,toastr.success,toastr.info,toastr.error
            toastr.error("没有登录");
        } else {
            let tmp_url = detail_url + "?nickname=" + cur_nickname;
            jQuery.ajax({
                type: "get",
                url: tmp_url,
                success: function (response) {
                    if (response.code == 200) {
                        let ud = response.result;
                        frm_userid = ud.id;
                        frm_nickname = ud.nickname;
                        frm_cnname = ud.cnname;
                        frm_phonenumber = ud.phonenumber;
                        frm_sex = ud.sex;
                        frm_title = ud.title;
                        frm_remark = ud.remark;
                        frm_createdtime = ud.createdtime;
                        frm_permits = ud.permits;
                    } else {
                        toastr.error("获取用户信息失败:" + response.result);
                    }
                },
                error: function (err) {
                    toastr.error("获取用户信息错误:" + err);
                },
            });
        }
    }

    function saveDetail() {
        let udata = {
            id: frm_userid,
            nickname: frm_nickname,
            cnname: frm_cnname,
            phonenumber: frm_phonenumber,
            sex: frm_sex,
            title: frm_title,
            remark: frm_remark,
        };
        jQuery.ajax({
            type: "post",
            url: detail_url,
            data: JSON.stringify(udata),
            success: function (response) {
                if (response.code == 200) {
                    toastr.success("保存成功");
                } else {
                    toastr.error("保存失败" + response.result);
                }
            },
            error: function (err) {
                toastr.error("保存错误" + err);
            },
        });
    }

    function changePwd() {
        dlg_oldpwd = "";
        dlg_newpwd = "";
        dlg_cftpwd = "";
        jQuery("#user-modal").modal("show");
    }

    function submitChange() {
        if (dlg_newpwd == "") {
            toastr.error("新密码不允许为空");
        } else {
            if (dlg_newpwd != dlg_cftpwd) {
                toastr.error("新密码与确认密码不一致");
            } else {
                let cdata = {
                    target: frm_nickname,
                    oldpwd: dlg_oldpwd,
                    newpwd: dlg_newpwd,
                };
                jQuery.ajax({
                    type: "post",
                    url: change_url,
                    data: JSON.stringify(cdata),
                    success: function (response) {
                        if (response.code == 200) {
                            toastr.success("密码修改成功");
                            jQuery("#user-modal").modal("hide");
                        } else {
                            toastr.error("密码失败" + response.result);
                        }
                    },
                    error: function (err) {
                        toastr.error("密码修改出错" + err);
                    },
                });
            }
        }
    }
</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>个人设置</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!--  card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">个人账号信息</h3>
                            <div class="card-tools">
                                <button
                                    type="submit"
                                    class=""
                                    on:click={changePwd}
                                >
                                    <i class="bi bi-key" /> 修改密码
                                </button>
                                <button
                                    type="submit"
                                    class=""
                                    on:click={saveDetail}
                                >
                                    <i class="bi bi-save" /> 保存信息
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="imputUserId">用户ID</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="imputUserId"
                                            readonly="true"
                                            bind:value={frm_userid}
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="imputCNName">用户名</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="imputCNName"
                                            bind:value={frm_cnname}
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="imputSex">性别</label>
                                        <select
                                            class="form-control"
                                            style="width: 100%;"
                                            id="imputSex"
                                            bind:value={frm_sex}
                                        >
                                            <option value="M">男</option>
                                            <option value="F">女</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="imputNickName"
                                            >用户代码</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="imputNickName"
                                            readonly="true"
                                            bind:value={frm_nickname}
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="imputPhonenumber"
                                            >手机号码</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="imputPhonenumber"
                                            bind:value={frm_phonenumber}
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label for="imputTitle">职务</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="imputTitle"
                                            bind:value={frm_title}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="imputRemark">备注说明</label
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="imputRemark"
                                            bind:value={frm_remark}
                                        />
                                    </div>
                                    <div>
                                        <label for="pPermits">权限信息</label>
                                        <p id="pPermits">{frm_permits}</p>
                                        <p>本用户创建于 {frm_createdtime}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- / card -->
                </div>
            </div>
        </div>
    </section>
</div>
<!-- /Content Wrapper. -->
<!-- user modal dialog -->
<div class="modal fade" id="user-modal" data-backdrop="static">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">修改密码</h4>
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form class="form-lrpadding">
                    <div class="form-group row">
                        <label for="pnickname" class="col-sm-2 col-form-label"
                            >用户代码</label
                        >
                        <div class="col-sm-10">
                            <p id="pnickname">{frm_nickname}</p>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputOldpwd" class="col-sm-2 col-form-label"
                            >旧密码</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="password"
                                class="form-control"
                                id="inputOldpwd"
                                bind:value={dlg_oldpwd}
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputNewpwd" class="col-sm-2 col-form-label"
                            >新密码</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="password"
                                class="form-control"
                                id="inputNewpwd"
                                bind:value={dlg_newpwd}
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="inputCftpwd" class="col-sm-2 col-form-label"
                            >确认密码</label
                        >
                        <div class="col-sm-10">
                            <input
                                type="password"
                                class="form-control"
                                id="inputCftpwd"
                                bind:value={dlg_cftpwd}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-between">
                <button
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal">关闭</button
                >
                <button
                    type="button"
                    class="btn btn-primary"
                    on:click={submitChange}>确认修改</button
                >
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<style>
</style>
